var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.project
        ? _c("PageHeadContainer", {
            attrs: { title: _vm.project.name },
            scopedSlots: _vm._u(
              [
                _vm.projectCompleted
                  ? {
                      key: "status",
                      fn: function () {
                        return [
                          _c("CardInfoChip", {
                            attrs: { message: "Completed" },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                {
                  key: "icons",
                  fn: function () {
                    return [
                      _c(
                        "PageHeadIcon",
                        { attrs: { content: _vm.period } },
                        [_c("ClockIcon", { staticClass: "h-5 w-5" })],
                        1
                      ),
                      _c(
                        "PageHeadIcon",
                        { attrs: { content: _vm.createdAt } },
                        [_c("CalendarIcon", { staticClass: "h-5 w-5" })],
                        1
                      ),
                      _c(
                        "PageHeadIcon",
                        { attrs: { content: _vm.location } },
                        [_c("LocationIcon", { staticClass: "h-5 w-5" })],
                        1
                      ),
                      _vm.isAdmin
                        ? _c(
                            "PageHeadIcon",
                            { attrs: { content: _vm.manager } },
                            [_c("UserIcon", { staticClass: "h-5 w-5" })],
                            1
                          )
                        : _vm._e(),
                      _vm._t("default"),
                    ]
                  },
                  proxy: true,
                },
                _vm.isActionsShown
                  ? {
                      key: "actions",
                      fn: function () {
                        return [
                          _vm.projectCompleted
                            ? _c("UiButton", {
                                attrs: {
                                  processing: _vm.statusProcessing,
                                  buttonText: "Reopen",
                                  variant: "secondary",
                                },
                                on: { click: _vm.reopenProject },
                              })
                            : _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  _c("UiButton", {
                                    staticClass: "mx-2",
                                    attrs: {
                                      processing: _vm.statusProcessing,
                                      buttonText: "Complete",
                                      variant: "secondary",
                                    },
                                    on: { click: _vm.completeProject },
                                  }),
                                  _c("UiButton", {
                                    attrs: { buttonText: "Edit" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("edit")
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }